import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import useSearchParams from 'modules/core/hooks/useSearchParams'
import i18n from 'modules/core/lib/i18n'

interface Params {
  createdRoleId: number
}

const Component = () => {
  const { navigation } = useNavigation()
  const params = useSearchParams<Params>()

  const footer = (
    <>
      <Button.Router
        type="secondary"
        disabled={!params.createdRoleId}
        to={navigation.employees.jobCatalog.role.settings.fullPath({ id: params.createdRoleId })}
      >
        {i18n.t('employees.orgchart.role_created_modal.go_to_settings')}
      </Button.Router>
      <Button.Router type="primary" to={navigation.employees.organizationChart.fullPath()}>
        {i18n.t('employees.orgchart.role_created_modal.stay_in_the_org_chart')}
      </Button.Router>
    </>
  )

  return (
    <Modal
      illustration="check"
      title={i18n.t('employees.orgchart.role_created_modal.title')}
      description={i18n.t('employees.orgchart.role_created_modal.description')}
      footer={footer}
    />
  )
}

export default Component
